export interface IGetOrderByIdFiltersDto {
    populate?: string;
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
